import { Autocomplete, Box, MenuItem, Select, styled } from "@mui/material"

export const DropdownFilterContainer = styled(Box)(() => ({
  padding: "10px 0 10px 0",
  marginLeft: "12px",
}))

export const StyledSelect = styled(Select)(() => ({
  height: "40px",
  width: "200px",
  fontSize: "14px",
  marginTop: "5px",
  backgroundColor: "#FFFFFF",
}))

export const StyledAutoComplete = styled(Autocomplete)(() => ({
  height: "40px",
  width: "200px",
  fontSize: "14px",
  marginTop: "5px",
  backgroundColor: "#FFFFFF",
}))

export const StyledMenuItem = styled(MenuItem)(() => ({
  minHeight: "40px",
  width: "180px",
  fontSize: "14px",
  borderRadius: "5px",
  margin: "3px 10px",
  whiteSpace: "normal",
}))

export const DropdownWrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}))

export const DropdownSearchFilter = styled(Box)(() => ({
  maxHeight: "40px",
  maxWidth: "160px",
  marginBottom: "10px",
  position: "sticky",
  top: "0px",
  backgroundColor: "#fff",
  zIndex: 1,
}))
